export default __webpack_public_path__ + "static/media/banner_achievements.6ecadb1b.webp";